import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import ColStatus from '../col-status'

const ArchiveList = ({ headers, list, fetchArchive }) => {
  useEffect(() => { fetchArchive() }, [])

  const DisplayDetails = item => {
    const { requestDate, notes } = item

    return (
      <ul className="my-3 text-sm">
        <li>{`Request Date: ${requestDate}`}</li>
        <li>{`Notes: ${notes}`}</li>
      </ul>
    )
  }

  return (
    <div className="client-archive-list">
      <div className="mt-5">
        <div className="overflow-auto">
          <Table classes="w-full border-collapse">
            <THead classes="text-xs bg-lightgray font-semibold">
              {headers.map((header, key) => (
                <TCol classes="p-3" key={key}>
                  {header.name}
                </TCol>
              ))}
            </THead>
            <TBody>
              {list.map(item => (
                <TRow classes="border-t text-sm hover:bg-gray-100"
                  key={item.id} PassedComponent={() => DisplayDetails(item.details)}>
                  <TCol classes="p-3">{item.createDate}</TCol>
                  <TCol classes="p-3">{item.leadType}</TCol>
                  <TCol classes="p-3">{item.requestDate}</TCol>
                  <TCol classes="p-3 text-primary-orange">
                    <a href={item.spaceLink}>{item.space}</a>
                  </TCol>
                  <ColStatus classes="p-3 font-semibold text-xs" status={item.status} />
                </TRow>
              ))}
            </TBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

ArchiveList.propTypes = {
  fetchArchive: PropTypes.func.isRequired,
  headers: PropTypes.array.isRequired,
  list: PropTypes.array,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.client.archive.headers,
  list: bookings.client.archive.list,
})

const mapDispatchToProps = {
  fetchArchive: bookingActions.fetchClientArchive,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveList)
